export const LOGIN_ROUTE = '/login';
export const HOME_ROUTE = '/home';
export const REGISTER_ROUTE = '/register';

// Where a visitor belongs, given the signed-in state.
//
// PURE, and the ONE place the rule is written. The login page and the home
// page both applied it, but the home page guarded on sign-in alone, so an
// account with no organization that loaded /home directly stayed on a page
// that holds nothing but a heading and Logout.
export function routeForUser({ isAuthenticated, user } = {}) {
  if (!isAuthenticated || !user) {
    return LOGIN_ROUTE;
  }
  return user.organizationId ? HOME_ROUTE : REGISTER_ROUTE;
}

export default routeForUser;
